import { CheckCircle2, Circle } from "lucide-react";
import { MIGRATION } from "../../../constants/testIds";
import { Button } from "../../ui/button";

const MID_CYCLE_FIELDS = [
  { key: "remaining_days", label: "Remaining membership days" },
  { key: "remaining_sessions", label: "Remaining PT sessions" },
  { key: "freezes_taken", label: "Freezes already taken" },
  { key: "advance_amount", label: "Advance / wallet credit" },
  { key: "dues_amount", label: "Dues outstanding" },
];

// SCR-P04-13 - a read-only summary of which mid-cycle fields got mapped in Step 2 (the mapping
// step IS where these get set). Detailed attendance/payment-history import is intentionally kept
// out of scope this phase - skipping it entirely still lets a migration complete end-to-end.
export function MidCycleStep({ mapping, onBack, onContinue }) {
  const mappedFields = new Set(Object.values(mapping).filter(Boolean));
  return (
    <div className="space-y-4">
      <div className="solid-surface rounded-[14px] p-5">
        <p className="text-sm font-semibold mb-3" style={{ color: "var(--scarlet-text)" }}>Mid-cycle balances carried over</p>
        <div className="space-y-2">
          {MID_CYCLE_FIELDS.map((f) => {
            const mapped = mappedFields.has(f.key);
            return (
              <div key={f.key} data-testid={MIGRATION.midCycleField(f.key)} className="flex items-center gap-2 text-sm" style={{ color: "var(--scarlet-text)" }}>
                {mapped ? <CheckCircle2 size={15} style={{ color: "#3FA65B" }} /> : <Circle size={15} style={{ color: "var(--scarlet-text-secondary)" }} />}
                {f.label} {!mapped && <span style={{ color: "var(--scarlet-text-secondary)" }}>- not mapped, will default per-member</span>}
              </div>
            );
          })}
        </div>
      </div>
      <div data-testid={MIGRATION.midCycleSkipHistory} className="rounded-[10px] p-3 text-xs" style={{ background: "var(--scarlet-surface-2)", color: "var(--scarlet-text-secondary)" }}>
        Detailed attendance/payment history import is optional and not required to go live - skipping it entirely still lets this migration complete.
      </div>
      <div className="flex justify-between">
        <Button variant="outline" onClick={onBack}>Back</Button>
        <Button data-testid={MIGRATION.wizardContinueButton} onClick={onContinue} style={{ background: "var(--scarlet-accent)", color: "#fff" }}>Continue to Preview</Button>
      </div>
    </div>
  );
}
